import styled from 'styled-components'
// themes
import { colors } from 'themes'
// components
import { Paper as PaperOrigin } from 'components/UI'

export const Paper = styled(PaperOrigin)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  position: relative;
`

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  border-bottom: 1px solid ${colors.gray220};
`

export const Tab = styled.div<{ $active: boolean }>`
  cursor: pointer;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${({ $active }) => ($active ? colors.blue500 : colors.gray400)};
  border-bottom: 2px solid ${({ $active }) => ($active ? colors.blue500 : 'transparent')};
`

export const TabPanel = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
`

export const LevelSelectWrapper = styled.div`
  margin: 12px 0;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
`
